/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_Support_TitleInputs */

const en_home_trust_support_title = /** @type {(inputs: Home_Trust_Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24/7 Claims Assistance`)
};

const fr_home_trust_support_title = /** @type {(inputs: Home_Trust_Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistance aux réclamations 24/7`)
};

/**
* | output |
* | --- |
* | "24/7 Claims Assistance" |
*
* @param {Home_Trust_Support_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_trust_support_title = /** @type {((inputs?: Home_Trust_Support_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_Support_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_trust_support_title(inputs)
	return fr_home_trust_support_title(inputs)
});